import { render } from "./AppCard.vue?vue&type=template&id=8fb2520a&scoped=true"
const script = {}

import "./AppCard.vue?vue&type=style&index=0&id=8fb2520a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb2520a"]])

export default __exports__